import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 팔기 희망하는 조합을 선택하세요 ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" *설립 1년이 지난 조합만 거래 가능합니다. ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 선택하신 회사의 지분을")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 가지고 있지 않습니다. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_text = _resolveComponent("ag-text")!
  const _component_partnership_stake = _resolveComponent("partnership-stake")!
  const _component_ag_box = _resolveComponent("ag-box")!
  const _component_ag_img = _resolveComponent("ag-img")!
  const _component_ag_content = _resolveComponent("ag-content")!
  const _component_ag_button = _resolveComponent("ag-button")!
  const _component_ag_footer = _resolveComponent("ag-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ag_content, null, {
      default: _withCtx(() => [
        _createVNode(_component_ag_box, {
          pt: "8px",
          height: "100%"
        }, {
          default: _withCtx(() => [
            (_ctx.checkStakeList)
              ? (_openBlock(), _createBlock(_component_ag_box, { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ag_text, {
                      color: "black",
                      p: "0px 20px",
                      typography: "list17m"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_1
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ag_text, {
                      color: "primary",
                      pt: "8px",
                      pl: "20px",
                      dp: "block",
                      typography: "main14r"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stakeList, (stake, idx) => {
                      return (_openBlock(), _createBlock(_component_ag_box, {
                        key: stake.partnershipId,
                        p: "0px 20px",
                        style: {"border-bottom":"1px solid rgba(249, 249, 251, 1)"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_partnership_stake, {
                            idx: idx+1,
                            stake: stake,
                            "selected-index": _ctx.selectedIndex,
                            style: _normalizeStyle(_ctx.checkMinRetentionAsset(stake) || _ctx.checkValidateDate(stake) || !stake.shareTransactionFlag ? {opacity: 0.3} : ''),
                            onClick: ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'팔기 희망하는 조합을 선택하세요', 'clickContent':`${stake.partnershipName}`});(!_ctx.checkMinRetentionAsset(stake) && !_ctx.checkValidateDate(stake) && stake.shareTransactionFlag ? _ctx.selectAction(idx+1, stake) : '')}
                          }, null, 8, ["idx", "stake", "selected-index", "style", "onClick"])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_ag_box, {
                  key: 1,
                  dp: "flex",
                  "justify-content": "center",
                  "text-align": "center",
                  direction: "column",
                  width: "100%",
                  px: "20px"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ag_box, {
                      "margin-top": "64px",
                      "margin-bottom": "8px",
                      dp: "flex",
                      "justify-content": "center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ag_img, {
                          width: "40px",
                          height: "40px",
                          src: _ctx.selectCompany.partnershipLogo
                        }, null, 8, ["src"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ag_text, {
                      color: "black",
                      dp: "block",
                      typography: "tit16b"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.selectCompany.stockItemName), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ag_text, {
                      "margin-top": "24px",
                      dp: "block",
                      color: "black",
                      typography: 'list17m'
                    }, {
                      default: _withCtx(() => [
                        _hoisted_3,
                        _hoisted_4,
                        _hoisted_5
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ag_footer, {
      p: "20px",
      mb: "safeAreaBottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ag_box, {
          dp: "flex",
          gap: "sp10"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ag_button, {
              corner: "10px",
              outline: "primary",
              width: "100%",
              onClickCapture: _cache[0] || (_cache[0] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'하단버튼', 'clickContent':`${_ctx.previousButton}`});(_ctx.openTypeRef === 'selected' ? _ctx.$emit('close') : _ctx.previousProcess())})
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.previousButton), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_ag_button, {
              corner: "10px",
              fill: "primary",
              width: "100%",
              disabled: _ctx.checkStakeList && _ctx.selectedIndex === -1,
              onClickCapture: _cache[1] || (_cache[1] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'하단버튼', 'clickContent':`${_ctx.nextButton}`});_ctx.nextProcess()})
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.nextButton), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}